import React, { Component } from "react";
import {
  Container,
  Card,
  CardHeader,
  Button,
  CardBody,
  Row,
  Col,
} from "reactstrap";
import { connect } from "react-redux";
import "./Quotation.scss";
import AllQuotation from "./AllSRQuotation";
import FiltertRightbar from "./FiltersRightbar";
import {
  getSRQuotationtList,
  SetParams,
  FiltersShowRightSidebar,
  FilterClear,
} from "../../store/SRQuotation/actions";
import LoadingModel from "../LoadingModel";
import AllSRQuotation from "./AllSRQuotation";

class SRQuotationDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = { FilterToggle: false };
  }
  componentDidMount() {
    this.props.FilterClear();
    this.props.getSRQuotationtList({
      ...this.props.params,
      // pistatus: [0],
      search: "",
      start_date: "",
      end_date: "",
      userdepartment: "",
      department: "",
      page: 1,
    });
    this.props.SetParams({
      ...this.props.params,
      // mrstatus: [0],
      search: "",
      start_date: "",
      end_date: "",
      userdepartment: "",
      department: "",
      page: 1,
    });
  }

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            {this.props.loading && (
              <LoadingModel OpenModel={this.props.loading} />
            )}

            <Row>
              <Col lg={12}>
                <Card>
                  <CardHeader className="bg-transparent border-bottom ">
                    <h5 className="card-title-18 pt-2 d-inline-block">
                     SR Quotation Dashboard
                    </h5>
                    <div className="float-right">
                      <div className="d-inline-block">
                        <Button
                          type="button"
                          color="light"
                          className="waves-effect waves-light d-flex  mr-2"
                          onClick={() => this.props.FiltersShowRightSidebar()}
                        >
                          <i className="mdi mdi-filter"></i>
                          <span className="d-none d-lg-block ml-1">
                            Filters
                          </span>
                        </Button>
                      </div>
                      <Button
                        type="button"
                        color="primary"
                        className="waves-effect waves-light"
                        href="/NewSRQuotation/0"
                      >
                        New Quotation
                      </Button>
                    </div>
                  </CardHeader>
                  <CardBody className="pt-0">
                    <AllSRQuotation />
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <FiltertRightbar />
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
const mapStatetoProps = (state) => {
  const { QRowList, QRowListCount, params, filterdata, loading } =
    state.SRQuotation;
  return {
    QRowList,
    QRowListCount,
    params,
    filterdata,
    loading,
  };
};

export default connect(mapStatetoProps, {
  getSRQuotationtList,
  SetParams,
  FiltersShowRightSidebar,
  FilterClear,
})(SRQuotationDashboard);
